<template>
  <div class="finish">
    <img ref="img" src="../assets/c.png">
    <p class="success-text">新密码设置成功！</p>
    <el-button class="to-login" type="primary" @click="next">立即登录</el-button>
  </div>
</template>

<script>
const themeSuccessImg = {
  themeGreen: require('../assets/c-themeGreen.png'),
  themeBlue: require('../assets/c-themeBlue.png'),
  themeOrange: require('../assets/c-themeOrange.png'),
  themeBrown: require('../assets/c-themeBrown.png')
}
export default {
  name: 'finish',
  methods: {
    next () {
      this.$router.push({ name: 'login' })
    }
  },
  mounted () {
    let themeColor = document.documentElement.getAttribute('theme') || (this.$theme && this.$theme.themeColor)
    if (themeColor) {
      this.$refs.img.src = themeSuccessImg[themeColor]
    }
  }
}

</script>

<style lang="scss">
  @import "@/assets/scss/common.scss";

  .finish {
    width: 100%;
    text-align: center;
    .el-icon-success {
      display: block;
      font-size: 80px;
      width: 80px;
      margin: 0 auto;
      color: #67c23a;
      padding-bottom: 40px;
    }
    .success-text{
      font-size: 16px;
      margin-bottom: 20px;
      color: #7f7f7f;
    }
    .to-login {
      margin-top: 12px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/system/forgetPassword/finish.vue